import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MobilePushNotificationService {
  public PushNotification: any;

  constructor() {}

  isSupported(): boolean {
    return false;
  }

  isPermitted(): boolean {
    return false;
  }

  checkPermission(): Observable<boolean> {
    return new Observable((observer) => {
      observer.next(false);
      observer.complete();
    });
  }

  requestPermission(): Observable<boolean> {
    return this.checkPermission();
  }

  init(subscriptions: any) {}

  /**
   * Promotion push notifications (#11620) exist only in a native template
   * build; the web/kiosk stub reports "not subscribed" so callers need no
   * platform check of their own.
   */
  async enablePromotionNotifications(storeAlias: string): Promise<boolean> {
    return false;
  }

  addSubscription(storeId: number, storeAlias: string, subscriptions: any) {}

  removeSubscription(storeId: number, subscriptions: any) {}
}
